import { getOrderPreview, createOrder, getOrder } from '@/api/orders.js';
import { createPaymentIntent, completePaymentIntent } from '@/services/payments.service.js';

const state = {
  coupon: {
    code: null,
    discount: 0,
  },
  order: {},
  paymentMethodType: null,
  paymentMethodId: null,

  billingData: {},

  // track upload of docs
  upload: {
    status: false,
    message: '',
    progress: 0,
  },
};

const getters = {
  getCouponCode: state => state.coupon.code,
  couponDiscount(state) {
    return state.coupon.discount;
  },
};

const actions = {
  // ORDERS
  async getOrder({ commit }, payload) {
    getOrder(payload.id).then((response) => {
      commit('setOrder', response.data.data);
    });
  },
  PREVIEW_ORDER({ commit, state }, params) {
    params = _.get(params, 'paymentMethodType', null) === 'saved_card' ? { ...params, paymentMethodType: 'card' } : params;
    if (state.coupon.code) params.coupon = state.coupon.code;
    return getOrderPreview(params)
      .then(({ data: { data } }) => {
        commit('setOrder', data);
        return data;
      });
  },
  CREATE_ORDER({ commit, state }, params) {
    params = _.get(params, 'paymentMethodType', null) === 'saved_card' ? { ...params, paymentMethodType: 'card' } : params;
    if (state.coupon.code) params.coupon = state.coupon.code;
    return createOrder(params)
      .then(({ data: { data } }) => {
        commit('setOrder', data);
      });
  },
  CREATE_PAYMENT_INTENT({ commit }, params) {
    return createPaymentIntent(params)
      .then(({ data: { data: paymentIntent } }) => {
        if (paymentIntent.order) commit('setOrder', paymentIntent.order);
        return paymentIntent;
      });
  },
  COMPLETE_PAYMENT_INTENT({ commit }, { orderId, paymentIntentId }) {
    return completePaymentIntent(orderId, { gateway_id: paymentIntentId })
      .then(({ data: { data: paymentIntent } }) => {
        if (paymentIntent.order) commit('setOrder', paymentIntent.order);
        return paymentIntent;
      });
  },
};

const mutations = {
  setCoupon: (state, coupon) => {
    console.log('setCoupon', coupon);
    state.coupon.code = coupon.code;
    state.coupon.discount = coupon.discount;
  },
  setCouponCode(state, couponCode) {
    state.coupon.code = couponCode;
  },
  resetCoupon(state) {
    state.coupon.discount = 0;
  },
  setOrder: (state, order) => {
    state.order = order;
  },
  setPaymentMethodType(state, paymentMethodType) {
    state.paymentMethodType = paymentMethodType;
  },
  setPaymentMethodId(state, paymentMethodId) {
    state.paymentMethodId = paymentMethodId;
  },
  setBillingData(state, billingData) {
    state.billingData = billingData;
  },
  setUploadProgress: (state, params) => {
    state.upload.status = params.status;

    if (params.progress) {
      state.upload.progress = params.progress;
    }

    if (params.message) {
      state.upload.message = params.message;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
